import { RefObject, useContext, useEffect, useRef, useState } from "react";
import { MenuData } from "./MainMenu";
import { DispSize, WindowContext } from "./WindowContextProvider";

export interface MenuButtonProps {
    data: MenuData,
    bh: number,
    bw: number,
    fs: number,
}

export const MenuButton = ({data,bh,bw,fs}: MenuButtonProps) : React.JSX.Element => {
    const hgref: RefObject<HTMLCanvasElement | null> = useRef(null);
    const [highlited,setHighlited] = useState<boolean>(false);

    const paintMButton = () => {
        const ctx = hgref.current?.getContext('2d');
        if(ctx !== null && ctx !== undefined) {
            ctx.clearRect(0, 0, bw, 2*bh);
            ctx.imageSmoothingEnabled = true; 

            ctx.strokeStyle = highlited ? 'rgb(16, 61, 117)':'black';
            ctx.lineWidth = 3;
            if (data.offset !== undefined) {
                if(highlited) {
                    const gradient = ctx.createLinearGradient(data.offset.x + bh, 2 * bh, data.offset.x + bh, bh);
                    gradient.addColorStop(0, 'rgb(16, 61, 117)');
                    gradient.addColorStop(0.5, 'rgba(16, 61, 117, 0.4)');
                    gradient.addColorStop(1, 'rgba(16, 61, 117, 0)');
                    ctx.fillStyle = gradient;
                    ctx.beginPath();
                    ctx.moveTo(data.offset.x, bh);
                    ctx.lineTo(data.offset.x + bh, 2 * bh);
                    ctx.lineTo(bw, 2 * bh);
                    ctx.lineTo(bw, bh);
                    ctx.lineTo(data.offset.x + bh, bh);
                    ctx.fill();
                }

                ctx.beginPath();
                ctx.moveTo(data.offset.x, bh);
                ctx.lineTo(data.offset.x + bh, 2 * bh);
                ctx.lineTo(bw, 2 * bh);
                ctx.stroke();

                ctx.fillStyle = highlited ? 'black' : 'black';
                console.log('fs='+fs);
                ctx.font = `bold ${fs}px KoHo`;
                ctx.fillText(data.name, data.offset.x + bh, bh+fs/2);
            }

        }
    };

    useEffect(() => {
        if(hgref.current) {
            hgref.current.width = bw;
            hgref.current.height = 2*bh;
        }
        paintMButton();
    }, [data,highlited]);

    const mover = () => {
        setHighlited(true);
    };
    const mout = () => {
        setHighlited(false);
    };
    const onc = () => {
        data.clickCallback(data.id);
    };

    return(
        <button style={{height: `${2*bh}px`, width: '100%', zIndex: 99}} 
            className="MenuButton" onClick={onc}>
            <canvas style={{flex: 1, zIndex: 1}} ref={hgref} onMouseOver={mover} onMouseOut={mout} />
        </button>
    );
}